/**
 * file : Board.jsx
 * 설명 : 게시판 화면
 */

import Paging from "../components/Paging"
import { Link } from 'react-router-dom';

export default function Board() {
    const pageNumbers = [1, 2, 3, 4, 5];
    return (
        <div className="main" style={{ minHeight: '726px'}}>
            <div className="container text-center" style={{marginBottom: '2rem'}}>
                <h1 className="common-title--h1 text-gray-2">게시판</h1>
            </div>
            <div className="container">
                {/* ------------------------------------------ table 부분 ------------------------------------------------- */}
                <table className="table_board_for type_d">
                    <colgroup>
                        <col width="8%" />
                        <col width="*%;" />
                        <col width="20%" />
                        <col width="12%;" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">NO</th>
                            <th scope="col">제목</th>
                            <th scope="col">작성자</th>
                            <th scope="col">작성일</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageNumbers.map((Number) => (
                            <tr key={Number} className="m_detail_span">
                                <td>{ Number }</td>
                                <td className="text_left title"><Link to="/BoardDetail">제목</Link></td>
                                <td>홍길동</td>
                                <td className="m_line">2023-07-0{ Number }</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {/* ---------------------------------------- 페이징 처리 부분 ----------------------------------------------- */}
                <Paging />
                {/* ------------------------------------------- 검색 부분 -------------------------------------------------- */}
                <div className="board-search-01">
                    <fieldset>
                        <select className="select-type-01">
                            <option value="S">작성자</option>
                            <option value="S">제목</option>
                            <option value="C">내용</option>
                        </select>
                        <input type="text" title="검색어" name="find_word" className="input-type-01" />
                        <button className="small-btn">검색</button>
                    </fieldset>
                </div>
            </div>
        </div>
    )
}